module.exports = __webpack_public_path__ + "static/media/gender-men.7a44c6fb.svg";